import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { loadingToast } from "src/components_with_stories/toast/toast";
import { AppContext } from "src/context/AppContext";

import useIsLightMode from "./useIsLightMode";

const useNavigateAuthenticatedUserToHomePage = () => {
  const isLightMode = useIsLightMode();
  const navigate = useNavigate();

  const { isAuthenticated } = useContext(AppContext);

  useEffect(() => {
    if (isAuthenticated) {
      loadingToast("You are already signed in. Redirecting to home page...", isLightMode);
      setTimeout(() => {
        navigate("/");
      }, 2000);
    }
  }, [isAuthenticated]);

  return null;
};

export { useNavigateAuthenticatedUserToHomePage };
